import React, { useEffect, useMemo, useState } from 'react'
import { clone } from 'lodash-es'
import { createForm } from '@formily/core'
import { requestIdle } from '@designable/shared'
import { CheckCircleOutlined, SearchOutlined, CloseCircleOutlined } from '@ant-design/icons'
import { Button, Tag, Form, Input, Space, message } from 'antd'
//@ts-ignore
import Modal from "@/components/Modal/Modal";
//@ts-ignore
import Table from "@/biz/Table";
import Select from '@/components/Form/Select.jsx'
import StateData from '@/pages/MainPage/datas/StateData';
// import Table from '@/components/Table/Table';
import type { ColumnsType, TablePaginationConfig } from 'antd/es/table';
import type { FilterValue, SorterResult } from 'antd/es/table/interface';
//@ts-ignore
import useHTTP from '@/hooks/useHTTP.mjs'
import cls from 'classnames'
import { useStore } from '../../../store'
import { BusinessScenarioType } from '../types'
import StoryType from '@/components/SoftwareMap/nodes/BDSUMMARY/StoryType.jsx'
// import './styles.less'


interface IClickEventSetterProps {
  value?: BusinessScenarioType
  onChange?: (value: BusinessScenarioType) => void
}

interface TableParams {
  pagination?: TablePaginationConfig;
  sortField?: string;
  sortOrder?: string;
  filters?: Record<string, FilterValue>;
}

const columns = [
  {
    title: "程序模块名称",
    dataIndex: "bdName",
    component: <Table.ViewText />,
  },
  {
    title: "程序模块代码",
    dataIndex: "bdNo",
    component: <Table.ViewText />,
  },
  {
    title: "用户场景类型",
    dataIndex: "storyType",
    component: <Table.ViewDict dict={Object.fromEntries(StoryType)} />,
  },
  {
    title: "用户场景标题",
    dataIndex: "algTitle",
    component: <Table.ViewText />,
  },

  {
    title: "版本号",
    dataIndex: "ver",
    width: 60,
    getValue: ({ rev, sVer }) => `${sVer}.${rev}`,
    component: <Table.ViewText />,
  },

  {
    title: "模型成品版本号",
    dataIndex: "patternRevConcatString",
    width: 120,
    component: <Table.ViewText />,
  },
].filter((v) => v);


export const DafaModal: React.FC<IClickEventSetterProps> = (props) => {
  const http = useHTTP();
  const prjData = useStore((s) => s.prjData);
  const [tabeleData, setTableData] = useState();
  const [loading, setLoading] = useState(false);
  const [tableParams, setTableParams] = useState<TableParams>({
    pagination: {
      current: 1,
      pageSize: 100,
    },
  });
  const [modalVisible, setModalVisible] = useState(false)
  const [innerVisible, setInnerVisible] = useState(false)
  const copyVal = clone(props.value);
  const [selectedRowKeys, setSelectedRowKeys] = useState([]);
  const [selectedRow, setSelectedRow] = useState<BusinessScenarioType>(undefined);
  
  const initval = {
    uiUserCode: '',
    uiName: ''
  }
  
  useEffect(() => {
    if (modalVisible) {
      setSelectedRowKeys(copyVal?.id ? [copyVal.id] : [])
      setSelectedRow(copyVal || {})
      requestIdle(
        () => {
          setInnerVisible(true)
        },
        {
          timeout: 100,
        }
      )
      fetchData(initval);
    } else {
      setInnerVisible(false)
    }
  }, [modalVisible])
  const form = useMemo(() => {
    return createForm({
      values: {
        ...copyVal
      },
    })
  }, [modalVisible, props.value])
  const openModal = () => setModalVisible(true)
  const closeModal = () => setModalVisible(false)
  const handleRowClick = (record) => {
    setSelectedRowKeys([record.pkid]);
    setSelectedRow({id: record.pkid, type: record.algType, name: record.algTitle})
  };

  const rowSelection = {
    selectedRowKeys,
    onChange: (keys, selectedRows) => {
      setSelectedRowKeys(keys);
      const record = selectedRows[0]
      setSelectedRow({id: record.pkid, type: record.algType, name: record.algTitle})
    },
  };

  const fetchData = (query?: any) => {
    setLoading(true);
    http.get('/dmbds/scenes', {
      stsCodes: 'RLS,REVISE',
      sortMode: 1,
      algType: 'DATAFLOW',
      prjId: prjData.prjId,
      bfId: prjData.pkid,
      sVer: prjData.sVer,
      ...query,
    }).then((data) => {
        setTableData(data)
        setLoading(false);
        setTableParams({
          ...tableParams,
          pagination: {
            ...tableParams.pagination,
            total: 200,
          },
        });
      }).catch(err => {
        setLoading(false);
      });
  };

  const onFinish = (values: any) => {
    fetchData(values);
  };

  return (
    <>
      <div className="flex min-h-8 cursor-pointer items-center justify-between rounded-lg border border-gray-200 bg-white shadow-xs hover:shadow-md">
        <div className="flex w-0 grow items-center space-x-1 rounded-lg bg-components-input-bg-normal hover:bg-components-input-bg-normal">
          <Input
            value={copyVal?.name}
            bordered={false}
            readOnly
          />
        </div>
        {copyVal?.id && <div
          title="清除用户场景"
          onClick={() => props.onChange(undefined)}
          className="flex h-full shrink-0 items-center py-2 pl-2 pr-2.5 border-r-[1px]"
        >
          <CloseCircleOutlined />
        </div>}
        <div
          title="选择用户场景"
          onClick={openModal}
          className="flex h-full shrink-0 items-center py-2 pl-2 pr-2.5"
        >
          <SearchOutlined />
        </div>
      </div>  
      <Modal
        title="关联用户场景"
        width={1280}
        style={{ top: 20 }}
        bodyStyle={{
          overflow: "auto",
          display: "flex",
          flexDirection: "column",
          maxHeight: "calc(80vh - 100px)",
          minHeight: 320,
          background: "#fff",
          padding: "16px 24px",
        }}
        centered
        transitionName=""
        maskTransitionName=""
        open={modalVisible}
        onCancel={closeModal}
        destroyOnClose
        onOk={() => {
          if (selectedRowKeys && selectedRowKeys.length > 0) {
            props.onChange(selectedRow);
            closeModal();
          } else {
            message.warning("请先进行选择");
          }
        }}
      >
        {innerVisible && (
          <>
            <Form
              name="queryForm"
              // labelCol={{ span: 8 }}
              // wrapperCol={{ span: 16 }}
              layout="vertical"
              initialValues={initval}
              onFinish={onFinish}
              autoComplete="off"
              size="middle"
            >
              <Space>
                <Form.Item name="bdName" label="程序模块名称">
                  <Input size="middle" placeholder="请输入" allowClear />
                </Form.Item>
                <Form.Item name="bdNo" label="程序模块代码">
                  <Input size="middle" placeholder="请输入" allowClear />
                </Form.Item>
                <Form.Item name="algTitle" label="用户场景标题">
                  <Input size="middle" placeholder="请输入" allowClear />
                </Form.Item>
                <Form.Item
                  style={{ width: "200px" }}
                  name="storyType"
                  label="用户场景类型"
                >
                  <Select placeholder="请选择" allowClear options={StoryType} />
                </Form.Item>
       

                <Form.Item
                  style={{ width: "120px" }}
                  label=" "
                  wrapperCol={{ offset: 8 }}
                >
                  <Button
                    //@ts-ignore
                    icon={<SearchOutlined />}
                    type="primary"
                    htmlType="submit"
                  >
                    搜索
                  </Button>
                </Form.Item>
              </Space>
            </Form>

            <Table
              loading={loading}
              rowSelection={{
                type: "radio",
                ...rowSelection,
              }}
              rowKey={"pkid"}
              columns={columns}
              dataSource={tabeleData}
              onRow={(record) => ({
                onClick: () => handleRowClick(record), // 点击行选中
              })}
            />
          </>
        )}
      </Modal>
    </>
  );
}
